const names = [
  'Ahmet', 'Merdan', 'Serdar'
]

export default names



// WEBPACK FOOTER //
// ./src/libraries/names.js